module.exports = __webpack_public_path__ + "img/prize-01.2c149581.png";